import { languageToUrl } from '../utils/languageUtils';
export const getCommunityUrlPublic = () => {
  const languageMap = {
    en: 'https://community.hubspot.com',
    de: 'https://community.hubspot.com/?profile.language=de',
    es: 'https://community.hubspot.com/?profile.language=es',
    pt: 'https://community.hubspot.com/?profile.language=pt-br',
    fr: 'https://community.hubspot.com/?profile.language=fr',
    ja: 'https://community.hubspot.com/?profile.language=ja'
  };
  return languageToUrl(languageMap);
};
export const getKnowledgeBaseUrlPublic = () => {
  const languageMap = {
    en: 'https://knowledge.hubspot.com',
    de: 'https://knowledge.hubspot.com/de',
    es: 'https://knowledge.hubspot.com/es',
    pt: 'https://knowledge.hubspot.com/pt',
    fr: 'https://knowledge.hubspot.com/fr',
    ja: 'https://knowledge.hubspot.com/jp'
  };
  return languageToUrl(languageMap);
};
export const getLanguagesUrlPublic = () => {
  const publicKBDomain = getKnowledgeBaseUrlPublic();
  return `${publicKBDomain}/account/hubspot-language-offerings`;
};
export const getAcademyUrlPublic = () => {
  const languageMap = {
    en: 'https://academy.hubspot.com',
    de: 'https://academy.hubspot.de',
    es: 'https://academy.hubspot.com/es',
    pt: 'https://academy.hubspot.com/pt',
    fr: 'https://academy.hubspot.fr',
    ja: 'https://academy.hubspot.jp'
  };
  return languageToUrl(languageMap);
};
export const getStartupsUrlPublic = utm_content => {
  const languageMap = {
    en: 'https://www.hubspot.com/startups',
    de: 'https://www.hubspot.de/startups',
    es: 'https://www.hubspot.es/startups',
    pt: 'https://br.hubspot.com/startups',
    fr: 'https://www.hubspot.fr/startups',
    ja: 'https://www.hubspot.jp/startups'
  };
  const url = languageToUrl(languageMap);
  return utm_content ? `${url}?utm_content=${utm_content}` : url;
};
export const getNonProfitsUrlPublic = utm_content => {
  const languageMap = {
    en: 'https://www.hubspot.com/nonprofits',
    de: 'https://www.hubspot.de/nonprofits',
    es: 'https://www.hubspot.es/nonprofits',
    pt: 'https://br.hubspot.com/nonprofits',
    fr: 'https://www.hubspot.fr/nonprofits',
    ja: 'https://www.hubspot.jp/nonprofits'
  };
  const url = languageToUrl(languageMap);
  return utm_content ? `${url}?utm_content=${utm_content}` : url;
};
export const getMarketingUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/products/marketing',
    de: 'https://www.hubspot.de/products/marketing',
    es: 'https://www.hubspot.es/products/marketing',
    pt: 'https://br.hubspot.com/products/marketing',
    fr: 'https://www.hubspot.fr/products/marketing',
    ja: 'https://www.hubspot.jp/products/marketing'
  };
  return languageToUrl(languageMap);
};
export const getServiceUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/products/service',
    de: 'https://www.hubspot.de/products/service',
    es: 'https://www.hubspot.es/products/service',
    pt: 'https://br.hubspot.com/products/service',
    fr: 'https://www.hubspot.fr/products/service',
    ja: 'https://www.hubspot.jp/products/service'
  };
  return languageToUrl(languageMap);
};
export const getSalesUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/products/sales',
    de: 'https://www.hubspot.de/products/sales',
    es: 'https://www.hubspot.es/products/sales',
    pt: 'https://br.hubspot.com/products/sales',
    fr: 'https://www.hubspot.fr/products/sales',
    ja: 'https://www.hubspot.jp/products/sales'
  };
  return languageToUrl(languageMap);
};
export const getCMSUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/products/cms',
    de: 'https://www.hubspot.de/products/cms',
    es: 'https://www.hubspot.es/products/cms',
    pt: 'https://br.hubspot.com/products/cms',
    fr: 'https://www.hubspot.fr/products/cms',
    ja: 'https://www.hubspot.jp/products/cms'
  };
  return languageToUrl(languageMap);
};
export const getMarketplaceBaseUrl = () => {
  const languageMap = {
    en: 'https://ecosystem.hubspot.com/marketplace',
    de: 'https://ecosystem.hubspot.com/de/marketplace',
    es: 'https://ecosystem.hubspot.com/es/marketplace',
    pt: 'https://ecosystem.hubspot.com/pt/marketplace',
    fr: 'https://ecosystem.hubspot.com/fr/marketplace',
    ja: 'https://ecosystem.hubspot.com/ja/marketplace'
  };
  return languageToUrl(languageMap);
};
export const getAppMarketplaceUrl = () => {
  const marketPlaceUrl = getMarketplaceBaseUrl();
  return `${marketPlaceUrl}/apps`;
};
export const getKBPaymentsUrlPublic = appendPath => {
  const publicKBDomain = getKnowledgeBaseUrlPublic();
  const baseUrl = `${publicKBDomain}/payments/payments-frequently-asked-questions`;
  return appendPath ? `${baseUrl}${appendPath}` : baseUrl;
};
export const getKBShareFormsUrlPublic = () => {
  const publicKBDomain = getKnowledgeBaseUrlPublic();
  return `${publicKBDomain}/forms/how-can-i-share-a-hubspot-form-if-im-using-an-external-site`;
};
export const getKBEmbedCTAUrlPublic = () => {
  const publicKBDomain = getKnowledgeBaseUrlPublic();
  return `${publicKBDomain}/ctas/add-ctas-to-your-pages`;
};
export const getKBTrackingCodeUrlPublic = () => {
  const publicKBDomain = getKnowledgeBaseUrlPublic();
  return `${publicKBDomain}/account/install-the-hubspot-tracking-code`;
};
export const getMicrositesExamplesUrl = () => {
  return 'https://www.hubspot.com/customer-spotlight';
};
export const getKBMembershipsUrlPublic = () => {
  const publicKBDomain = getKnowledgeBaseUrlPublic();
  return `${publicKBDomain}/cms-general-user-guide-v2/memberships`;
};
export const getMembershipsExamplesUrl = () => {
  return 'https://www.hubspot.com/customer-spotlight';
};
export const getDevelopersQuickStartGuideUrl = () => {
  return 'https://developers.hubspot.com/docs/cms/quickstart-guide';
};
export const getDevelopersAndApiDocsBaseUrl = () => {
  return 'https://developers.hubspot.com/docs/api/overview';
};
export const getSecurityAndComplianceUrl = () => {
  return 'https://www.hubspot.com/security';
};
export const getTemplatesMarketplaceUrl = () => {
  const marketPlaceUrl = getMarketplaceBaseUrl();
  return `${marketPlaceUrl}/website-themes`;
};
export const getKBImportToolUrlPublic = () => {
  const publicKBDomain = getKnowledgeBaseUrlPublic();
  return `${publicKBDomain}/cms-general-user-guide-v2/import-your-site-pages`;
};
export const getDevelopersApiDocsUrl = () => {
  return 'https://developers.hubspot.com/docs';
};
export const getSolutionsMarketplaceUrl = () => {
  const marketPlaceUrl = getMarketplaceBaseUrl();
  return `${marketPlaceUrl}/solutions`;
};
export const getWebsiteMigrationUrlPublic = () => {
  return 'https://www.hubspot.com/services/website-migration';
};
export const getOperationsUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/products/operations',
    de: 'https://www.hubspot.de/products/operations',
    es: 'https://www.hubspot.es/products/operations',
    pt: 'https://br.hubspot.com/products/operations',
    fr: 'https://www.hubspot.fr/products/operations',
    ja: 'https://www.hubspot.jp/products/operations'
  };
  return languageToUrl(languageMap);
};
export const getDataUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/products/data',
    de: 'https://www.hubspot.de/products/data',
    es: 'https://www.hubspot.es/products/data',
    pt: 'https://br.hubspot.com/products/data',
    fr: 'https://www.hubspot.fr/products/data',
    ja: 'https://www.hubspot.jp/products/data'
  };
  return languageToUrl(languageMap);
};
export const getDataSyncAppCollectionUrl = () => {
  return `${getAppMarketplaceUrl()}/apps-for-operations-teams`;
};
export const getBreezeUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/products/artificial-intelligence',
    de: 'https://www.hubspot.de/products/artificial-intelligence',
    es: 'https://www.hubspot.es/products/artificial-intelligence',
    pt: 'https://br.hubspot.com/products/artificial-intelligence',
    fr: 'https://www.hubspot.fr/products/artificial-intelligence',
    ja: 'https://www.hubspot.jp/products/artificial-intelligence'
  };
  const url = languageToUrl(languageMap);
  return `${url}?hubs_content=www.hubspot.com/products/crm/ai-crm&hubs_content-cta=smartcrm-faq-breeze`;
};
export const getHubspotCreditsUrlPublic = () => {
  const languageMap = {
    en: 'https://www.hubspot.com/pricing/hubspot-credits',
    de: 'https://www.hubspot.de/pricing/hubspot-credits',
    es: 'https://www.hubspot.es/pricing/hubspot-credits',
    pt: 'https://br.hubspot.com/pricing/hubspot-credits',
    fr: 'https://www.hubspot.fr/pricing/hubspot-credits',
    ja: 'https://www.hubspot.jp/pricing/hubspot-credits'
  };
  const url = languageToUrl(languageMap);
  return `${url}?hubs_content=www.hubspot.com/products/crm/ai-crm&hubs_content-cta=smartcrm-faq-breezeintelpricing`;
};
export const getLegalUrlPublic = () => {
  const languageMap = {
    en: 'https://legal.hubspot.com',
    de: 'https://legal.hubspot.com/de',
    es: 'https://legal.hubspot.com/es',
    pt: 'https://legal.hubspot.com/br',
    fr: 'https://legal.hubspot.com/fr',
    ja: 'https://legal.hubspot.com/jp'
  };
  return languageToUrl(languageMap);
};
export const getProductAndServicesCatalogUrlPublic = () => {
  return `${getLegalUrlPublic()}/hubspot-product-and-services-catalog#HubSpotCreditsRateSheet`;
};